<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="role-manager-tab">
	<div>
		<span jhiTranslate="site-admin.role.pane.title"></span>
		<span jhiTranslate="site-admin.role.pane.comment"></span>
	</div>
	<br/>
    <div class="row pb-3">
        <div class="col d-flex justify-content-end">
            <button class="btn btn-outline-info" (click)="addRole()"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i><span style="margin-left: 5px;" jhiTranslate="site-admin.role.add"></span></button>
        </div>
    </div>
	<div class="table-responsive" *ngIf="roles">
		<table class="table table-striped table-bordered table-curved" *ngIf="roles.length else nodata">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th [jhiSortBy]="ColumnLabels.ROLE_NAME"><span jhiTranslate="site-admin.role.columns.role-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.ROLE_DESCRIPTION"><span jhiTranslate="site-admin.role.columns.role-description"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.ROLE_TYPE"><span jhiTranslate="site-admin.role.columns.role-type"></span> <span class="fa fa-sort"></span></th>
				<th><span jhiTranslate="site-admin.role.columns.permissions"></span></th>
				<th [jhiSortBy]="ColumnLabels.STATUS"><span jhiTranslate="site-admin.role.columns.status"></span> <span class="fa fa-sort"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let role of roles; trackById: trackId; index as index">
				<td *ngIf="isSuperAdminRole(role)"> {{role.name}} </td>
				<td *ngIf="!isSuperAdminRole(role)">
					<a href="javascript:void(0)" (click)="editRole(role)">{{role.name}} </a>
				</td>
				<td>{{role.description}}</td>
				<td>{{'site-admin.role.type.' + role.roleType.name.toLowerCase() | translate}}</td>
				<td>
				<span>
					<span *ngIf="role.permissions[0]" class="site-admin-badge">{{role.permissions[0].description | translate}}</span>
					<span *ngIf="role.permissions.length > 1"
						  [title]="getPermissionsTitleFormat(role.permissions)"
						  style="padding-left: 5px; color: #428bca;"> and {{role.permissions.length - 1}} more</span>
				</span>
				</td>
				<td *ngIf="isSuperAdminRole(role) && role.active === true" jhiTranslate="site-admin.active"></td>
				<td *ngIf="isSuperAdminRole(role) && role.active === false" jhiTranslate="site-admin.inactive"></td>
				<!-- TODO deactivation logic is not defined yet -->
				<!--
				<td  *ngIf="!isSuperAdminRole(role)">
					<a href="javascript:void(0)" *ngIf="role.active === true">Deactivate</a>
					<a href="javascript:void(0)" *ngIf="role.active === false">Activate</a>
				</td> -->
				<td *ngIf="!isSuperAdminRole(role)">
					<span *ngIf="role.active === true" jhiTranslate="site-admin.active"></span>
					<span *ngIf="role.active === false" jhiTranslate="site-admin.inactive"></span>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="roles && roles.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
